import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

import Login from './scenes/Login/Login';
import UsersList from './scenes/Users/Users';
import Medication from './scenes/Medication/Medication';
import Admins from './scenes/Admins/Admins';
import User from './scenes/User/User';
import renderErrorPage from './scenes/Error/Error';

import API from './services/api';

const RenderReactComponent = (element) => {
  ReactDOM.render(element, document.getElementById('root'));
  registerServiceWorker();
};

const checkAuth = (next: Function, neededLevel: Array = ['user']) => {
  if (API.isLoggedIn()) {
    const { type } = API.getCurrentUser();

    if (neededLevel.includes(type)) {
      next();
    } else {
      renderErrorPage('Insufficient access level for page.');
    }
  } else {
    window.location.hash = '/login';
  }
};

const Routes = {
  '/': {
    '/': () => {
      if (window.location.hash.includes('access_token') || window.location.href.includes('state')) {
        return;
      }

      if (API.isLoggedIn()) {
        const { type } = API.getCurrentUser();
        window.location.hash = `/${type}`;
      } else {
        window.location.hash = '/login';
      }
    },
    '/login': () => {
      if (API.isLoggedIn()) {
        window.location.hash = '/';
        return;
      }

      RenderReactComponent(<Login />);
    },
    '/user': () => checkAuth(() => RenderReactComponent(<User />)),
    '/:su': () => checkAuth(() => RenderReactComponent(<UsersList />), ['admin', 'su']),
    '/:su/medication': () => checkAuth(() => RenderReactComponent(<Medication />), ['admin', 'su']),
    '/su/admins': () => checkAuth(() => RenderReactComponent(<Admins />), ['su']),
  },
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js